<template>
  <div v-if="state.alert.visible" class="app-alert" aria-live="assertive">
    <div :class="['alert', alertClass, 'shadow-sm', 'mb-0']">
      <span>{{ state.alert.message }}</span>
      <button type="button" class="btn-close ms-3" @click="hideAlert"></button>
    </div>
  </div>
</template>

<script>
import state, { hideAlert } from "@/state/app";

export default {
  name: "AppAlert",
  data() {
    return { state };
  },
  computed: {
    alertClass() {
      return {
        success: "alert-success",
        error: "alert-danger",
        warning: "alert-warning",
        info: "alert-info",
      }[this.state.alert.type] || "alert-info";
    },
  },
  methods: { hideAlert },
};
</script>

<style scoped>
.app-alert {
  position: fixed;
  top: 16px;
  left: 50%;
  z-index: 10001;
  width: min(92%, 460px);
  transform: translateX(-50%);
}

.alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
